import React from "react";
import { ProfilePicDialog } from "./ProfilePicDialog";
import getInitials from "@/utils/getInitials";
import { useAuthContext } from "@/hooks/useAuthContext";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shadcn/components/ui/avatar";
import { useUserContext } from "@/hooks/useUserContext";
import Loading from "./Loading";
import Logo from "./Logo";

export default function Topbar({ setRerender }) {
  const { userDoc } = useUserContext();

  const { user } = useAuthContext();

  if (!userDoc) return <Loading />;

  return (
    <div className="fixed w-full bg-background border border-border h-[72px] flex justify-between items-center px-5 z-[50]">
      <Logo size={"w-32"} />
      <div className="flex gap-2.5">
        <ProfilePicDialog setRerender={setRerender}>
          <Avatar className="h-12 w-12" role="button">
            <AvatarImage src={user.photoURL?.replace("=s96-c", "")} />
            <AvatarFallback className="bg-secondary text-primary">
              {getInitials(userDoc.name)}
            </AvatarFallback>
          </Avatar>
        </ProfilePicDialog>
      </div>
    </div>
  );
}
